
// @ts-nocheck


export const localeCodes =  [
  "ru",
  "uz",
  "en"
]

export const localeLoaders = {
  ru: [
    {
      key: "locale_ru_46json_b1fe22d3",
      load: () => import("#nuxt-i18n/b1fe22d3" /* webpackChunkName: "locale_ru_46json_b1fe22d3" */),
      cache: true
    }
  ],
  uz: [
    {
      key: "locale_uz_46json_b5705f93",
      load: () => import("#nuxt-i18n/b5705f93" /* webpackChunkName: "locale_uz_46json_b5705f93" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_d283349a",
      load: () => import("#nuxt-i18n/d283349a" /* webpackChunkName: "locale_en_46json_d283349a" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "src/app/config",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "ru",
      name: "Русский",
      iso: "ru-RU",
      files: [
        "/home/ubuntu/e_com_frontend/src/app/config/i18n/ru.json"
      ]
    },
    {
      code: "uz",
      name: "Oʻzbekcha",
      iso: "uz-UZ",
      files: [
        "/home/ubuntu/e_com_frontend/src/app/config/i18n/uz.json"
      ]
    },
    {
      code: "en",
      name: "English",
      iso: "en-US",
      files: [
        "/home/ubuntu/e_com_frontend/src/app/config/i18n/en.json"
      ]
    }
  ],
  defaultLocale: "ru",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "i18n",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "ECOM_LANGUAGE",
    cookieSecure: false,
    fallbackLocale: "ru",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "ru",
    name: "Русский",
    iso: "ru-RU",
    files: [
      {
        path: "/home/ubuntu/e_com_frontend/src/app/config/i18n/ru.json",
        cache: undefined
      }
    ]
  },
  {
    code: "uz",
    name: "Oʻzbekcha",
    iso: "uz-UZ",
    files: [
      {
        path: "/home/ubuntu/e_com_frontend/src/app/config/i18n/uz.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    name: "English",
    iso: "en-US",
    files: [
      {
        path: "/home/ubuntu/e_com_frontend/src/app/config/i18n/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/